




































import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Mobile } from "@/mixins/mobile";
import { CustomUmbrellaOrder } from "@/models/configurator/custom_umbrella";
import { FabricSwatch } from "@/models/products/fabric";
import { Fringe } from "@/models/configurator/configurator_options";
@Component
export default class QtyPicker extends mixins(Mobile) {
  @Prop() index!: number | string | undefined;
  @Prop() passedQty!: number | undefined;
  @Prop({ default: false }) allowZero!: boolean;
  @Prop() itemDets?: CustomUmbrellaOrder["canopy"];
  @Prop({ default: "" }) modelNumber!: string;
  @Prop({ default: "dark" }) theme!: "dark" | "light";
  private qty = this.allowZero ? 0 : 1;

  private static readonly MODEL_MIN_QTY: Record<string, number> = {
    "870ECU-SQ": 5,
    "882ECU-R": 5,
    "883NGU-SQ": 5
  };

  @Watch("passedQty", { immediate: true })
  udpateQty(): void {
    if (this.passedQty) {
      this.qty = this.passedQty;
    }
  }

  get btnClass(): string {
    const base =
      "w-8 h-8 rounded-full border-2 bg-transparent cursor-pointer inline-flex items-center justify-center p-0 transition-all duration-150";
    return this.theme === "light"
      ? `${base} border-brand-700 text-brand-700 hover:bg-brand-700 hover:text-white`
      : `${base} border-current text-current`;
  }

  get inputClass(): string {
    const base =
      "w-[50px] h-8 text-center text-base font-semibold rounded-md mx-2 p-0 qty-input";
    return this.theme === "light"
      ? `${base} border border-gray-300 bg-white text-brand-700`
      : `${base} border border-current bg-transparent`;
  }

  private get allItemFabrics(): FabricSwatch[] {
    const fabrics: FabricSwatch[] = [];
    if (!this.itemDets) return fabrics;
    if (this.itemDets.bindingFabric) fabrics.push(this.itemDets.bindingFabric);
    if (this.itemDets.ventTrimFabric)
      fabrics.push(this.itemDets.ventTrimFabric);
    if (this.itemDets.mainTrimFabric)
      fabrics.push(this.itemDets.mainTrimFabric);
    if (this.itemDets.mainTrimFabricInner)
      fabrics.push(this.itemDets.mainTrimFabricInner);
    if (this.itemDets.undersideFabric)
      fabrics.push(this.itemDets.undersideFabric);
    if (this.itemDets.ribFabric) fabrics.push(this.itemDets.ribFabric);
    if (this.itemDets.mainFabric) {
      this.itemDets.mainFabric.forEach(fabric => {
        fabrics.push(fabric);
      });
    }
    if (this.itemDets.valanceFabric) {
      this.itemDets.valanceFabric.forEach(fabric => {
        fabrics.push(fabric);
      });
    }
    if (this.itemDets.ventMiddleFabric) {
      this.itemDets.ventMiddleFabric.forEach(fabric => {
        fabrics.push(fabric);
      });
    }
    if (this.itemDets.ventTopFabric) {
      this.itemDets.ventTopFabric.forEach(fabric => {
        fabrics.push(fabric);
      });
    }
    return fabrics;
  }

  private static readonly STRIPE_EVEN_QTY_GRADES: string[] = [
    "b",
    "c",
    "d",
    "e",
    "f",
    "fp"
  ];

  private get hasStripedFabricRequiringEvenQty(): boolean {
    return this.allItemFabrics.some(fabric => {
      if (fabric.brand?.mfr?.handle === "recasens") return false;
      if (!QtyPicker.STRIPE_EVEN_QTY_GRADES.includes(fabric.grade))
        return false;
      return fabric.pattern_group?.includes("Stripes") ?? false;
    });
  }

  private get hasAcrylicFringe(): boolean {
    if (!this.itemDets) return false;
    if (this.itemDets.fringe === Fringe.None) return false;
    return (
      this.itemDets.fringeFabric?.some(
        (fabric: FabricSwatch) => fabric.fabric_type === "acrylic"
      ) ?? false
    );
  }

  private get modelMinQty(): number | null {
    return QtyPicker.MODEL_MIN_QTY[this.modelNumber] ?? null;
  }

  protected get qtyWarningMessages(): string[] {
    const messages: string[] = [];
    const minQty = this.modelMinQty;
    if (minQty && this.qty < minQty) {
      messages.push(`This model has a minimum quantity order of ${minQty}.`);
    }
    if (this.hasStripedFabricRequiringEvenQty && this.qty % 2 !== 0) {
      messages.push(
        "Striped fabrics (grades B–F+) must be ordered in even quantities."
      );
    }
    if (this.hasAcrylicFringe && this.qty < 2) {
      messages.push(
        "Acrylic fringe umbrellas require a minimum quantity of 2."
      );
    }
    this.$emit("toggleSubmit", messages.length > 0);
    return messages;
  }

  protected qtyKeypress(e: any): void {
    this.$emit("sendQty", this.qty, this.index);
  }

  protected minus(): void {
    const num = this.allowZero ? 0 : 1;
    if (this.qty > num) {
      this.qty--;
      this.$emit("sendQty", this.qty, this.index);
    }
  }

  protected add(): void {
    if (this.qty < 1000) {
      this.qty++;
      this.$emit("sendQty", this.qty, this.index);
    }
  }
}
